import { Component, Inject } from '@angular/core';
import { ModalComponent } from '../modal.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateHelper } from '@helpers/data-helper';

@Component({
  selector: 'app-modal-message',
  templateUrl: './modal-message.component.html',
  styleUrls: ['./modal-message.component.scss']
})
export class ModalMessageComponent extends ModalComponent<ModalMessageComponent>{

  private readonly _dateTicks = DateHelper.currentDate.getTime();

  public txtBtnClose: string = "Fechar";
  public message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
  ) {
    super()

    this.message = data
  }

  public getDataCy(dataCy: string) {
    return `${dataCy}-${this._dateTicks}`;
  }
}
